import _regeneratorRuntime from "/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

import { all } from 'redux-saga/effects';
/**
 * Helper to combine dependencies handlers for `runRouteDependecies`
 * Accepts infinite number of handlers objects ({'template': sagaHandler}) and returns exactly one for usage in `runRouteDependecies`
 * Supports same keys in the handlers objects
 * viz. `runRouteDependecies`
 */

var isValueFn = function isValueFn(entry) {
  return typeof entry[1] === 'function';
};

var wrapSagas = function wrapSagas(sagas) {
  return (
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var tasks;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tasks = sagas.map(function (saga) {
                return saga.apply(undefined, args);
              });
              _context.next = 3;
              return all(tasks);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    })
  );
};

function registerHandlersObjects(handlersObjects) {
  var register = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = handlersObjects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var dependencies = _step.value;
      var entries = Object.entries(dependencies).filter(isValueFn);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              route = _step2$value[0],
              saga = _step2$value[1];

          var sagas = register[route] || [];
          register[route] = sagas.concat(saga);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return register;
}

function createHandlers(register) {
  var handlers = {};
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = Object.entries(register)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          route = _step3$value[0],
          sagas = _step3$value[1];

      handlers[route] = wrapSagas(sagas);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return handlers;
}

export default function combineDependenciesHandlers() {
  for (var _len2 = arguments.length, handlersObjects = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    handlersObjects[_key2] = arguments[_key2];
  }

  var register = registerHandlersObjects(handlersObjects);
  return createHandlers(register);
}